module.exports = __webpack_public_path__ + "img/apple-icon-180.66a4c8ce.png";